module.exports = function(done, value){
  return {value: value, done: !!done};
};


//////////////////
// WEBPACK FOOTER
// ./~/_core-js@1.2.7@core-js/library/modules/$.iter-step.js
// module id = 125
// module chunks = 0